import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const ConfirmationModal = ({isOpened,handleCancle,title,description,handleConfirmation,buttonTitle}) => {
  return (
    <Dialog open={isOpened} onClose={handleCancle}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
           {description}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancle}>Cancel</Button>
        <Button onClick={handleConfirmation} variant="contained">
          {buttonTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmationModal;
